import calculateAge from '../calculators/calculate-age'

const determineAge = (ctx) => ({
  context: {
    age: calculateAge(ctx?.dob || {}),
  },
})

export default determineAge
